import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SignInComponent } from './sign-in/sign-in.component';
import { SignUpComponent } from './sign-up/sign-up.component';
import { SignOutComponent } from './sign-out/sign-out.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'sign-in',
    pathMatch: 'full'
  },
  {
    path: 'sign-in',
    component: SignInComponent,
    data: { title: 'Sign In' }
  },
  {
    path: 'reset-password/:verifycode',
    component: SignInComponent,
    data: { title: 'Reset Password' }
  },
  // {
  //   path: 'sign-up',
  //   component: SignUpComponent,
  //   data: { title: 'Sign Up' }
  // },
  {
    path: 'sign-out',
    component: SignOutComponent,
    data: { title: 'Sign Out' }
  },
  // {
  //   path: 'forgot-password',
  //   component: ForgotPasswordComponent,
  //   data: { title: 'Forgot Password' }
  // },
  {
    path: '**',
    redirectTo: 'sign-in'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthenticationRoutingModule { }
